import { UpsellBannerContent } from '../components/UpsellBanner';
import {
    MY01NV_Text,
    MY01MZ_MY01NA_Text,
    MY01N0_Text,
    MY01N1_Text,
    MY01O5_MY01O9_Text,
    MY01O6_MY01OA_Text,
    MY01O7_MY01OB_Text,
    MY01O8_MY01OC_Text,
    MY01NC_Text,
    MY01ND_MY01N3_Text,
    MY01NH_MY01NP_Text,
    MY01NF_MY01NQ_Text,
    MY01N2_MY01NB_MY01NI_MY01NR_Text,
    MY01OV_MY01OQ_Text,
    MY01OW_MY01OR_Text,
    MY01OX_MY01OS_Text,
    ubSwitchToNewEdgeLinkText,
    ubSwitchToEdgeLinkText,
    ubSwitchNowLinkText,
    ubLearnMoreLinkText,
    ubDownloadNowLinkText,
    ubTryNowLinkText,
} from '../components/EdgeUpsellStrings.locstring.json';
import loc from 'owa-localize';

export const win10_IE_Strings: UpsellBannerContent[] = [
    {
        contentId: 'MY01NV',
        contentMessage: loc(MY01NV_Text),
        contentLinkButtonText: loc(ubSwitchNowLinkText),
        contentLinkHref:
            'microsoft-edge:https://www.microsoft.com/edge/features?form=MY01NV&OCID=MY01NV',
    },
    {
        contentId: 'MY01MZ',
        contentMessage: loc(MY01MZ_MY01NA_Text),
        contentLinkButtonText: loc(ubTryNowLinkText),
        contentLinkHref:
            'microsoft-edge:https://www.microsoft.com/edge/features?form=MY01MZ&OCID=MY01MZ',
    },
    {
        contentId: 'MY01N0',
        contentMessage: loc(MY01N0_Text),
        contentLinkButtonText: loc(ubTryNowLinkText),
        contentLinkHref:
            'microsoft-edge:https://www.microsoft.com/edge/features?form=MY01N0&OCID=MY01N0',
    },
    {
        contentId: 'MY01N1',
        contentMessage: loc(MY01N1_Text),
        contentLinkButtonText: loc(ubSwitchNowLinkText),
        contentLinkHref:
            'microsoft-edge:https://www.microsoft.com/edge/features?form=MY01N1&OCID=MY01N1',
    },
    {
        contentId: 'MY01N2',
        contentMessage: loc(MY01N2_MY01NB_MY01NI_MY01NR_Text),
        contentLinkButtonText: loc(ubSwitchToEdgeLinkText),
        contentLinkHref:
            'microsoft-edge:https://www.microsoft.com/edge/features?form=MY01N2&OCID=MY01N2',
    },
    {
        contentId: 'MY01O5',
        contentMessage: loc(MY01O5_MY01O9_Text),
        contentLinkButtonText: loc(ubSwitchNowLinkText),
        contentLinkHref:
            'microsoft-edge:https://www.microsoft.com/edge/features?form=MY01O5&OCID=MY01O5',
        isBannerAggresive: true,
    },
    {
        contentId: 'MY01O6',
        contentMessage: loc(MY01O6_MY01OA_Text),
        contentLinkButtonText: loc(ubSwitchNowLinkText),
        contentLinkHref:
            'microsoft-edge:https://www.microsoft.com/edge/features?form=MY01O6&OCID=MY01O6',
        isBannerAggresive: true,
    },
    {
        contentId: 'MY01O7',
        contentMessage: loc(MY01O7_MY01OB_Text),
        contentLinkButtonText: loc(ubSwitchNowLinkText),
        contentLinkHref:
            'microsoft-edge:https://www.microsoft.com/edge/features?form=MY01O7&OCID=MY01O7',
        isBannerAggresive: true,
    },
    {
        contentId: 'MY01O8',
        contentMessage: loc(MY01O8_MY01OC_Text),
        contentLinkButtonText: loc(ubSwitchToNewEdgeLinkText),
        contentLinkHref:
            'microsoft-edge:https://www.microsoft.com/edge/features?form=MY01O8&OCID=MY01O8',
        isBannerAggresive: true,
    },
    {
        contentId: 'MY01OV',
        contentMessage: loc(MY01OV_MY01OQ_Text),
        contentLinkButtonText: loc(ubLearnMoreLinkText),
        contentLinkHref:
            'microsoft-edge:https://microsoftedgewelcome.microsoft.com/en-us/value?form=MY01OV&OCID=MY01OV',
        isEnUsOnly: true,
    },
    {
        contentId: 'MY01OW',
        contentMessage: loc(MY01OW_MY01OR_Text),
        contentLinkButtonText: loc(ubTryNowLinkText),
        contentLinkHref:
            'microsoft-edge:https://microsoftedgewelcome.microsoft.com/en-us/value?form=MY01OW&OCID=MY01OW',
        isEnUsOnly: true,
    },
    {
        contentId: 'MY01OX',
        contentMessage: loc(MY01OX_MY01OS_Text),
        contentLinkButtonText: loc(ubTryNowLinkText),
        contentLinkHref:
            'microsoft-edge:https://microsoftedgewelcome.microsoft.com/en-us/value?form=MY01OX&OCID=MY01OX',
        isEnUsOnly: true,
    },
];

export const win10_NonIE_Strings: UpsellBannerContent[] = [
    {
        contentId: 'MY01NC',
        contentMessage: loc(MY01NC_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref:
            'microsoft-edge:https://www.microsoft.com/edge/features?form=MY01NC&OCID=MY01NC',
    },
    {
        contentId: 'MY01ND',
        contentMessage: loc(MY01ND_MY01N3_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref:
            'microsoft-edge:https://www.microsoft.com/edge/features?form=MY01ND&OCID=MY01ND',
    },
    {
        contentId: 'MY01NH',
        contentMessage: loc(MY01NH_MY01NP_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref:
            'microsoft-edge:https://www.microsoft.com/edge/features?form=MY01NH&OCID=MY01NH',
    },
    {
        contentId: 'MY01NF',
        contentMessage: loc(MY01NF_MY01NQ_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref:
            'microsoft-edge:https://www.microsoft.com/edge/features?form=MY01NF&OCID=MY01NF',
    },
    {
        contentId: 'MY01NB',
        contentMessage: loc(MY01N2_MY01NB_MY01NI_MY01NR_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref:
            'microsoft-edge:https://www.microsoft.com/edge/features?form=MY01NB&OCID=MY01NB',
    },
    {
        contentId: 'MY01OQ',
        contentMessage: loc(MY01OV_MY01OQ_Text),
        contentLinkButtonText: loc(ubLearnMoreLinkText),
        contentLinkHref:
            'microsoft-edge:https://microsoftedgewelcome.microsoft.com/en-us/value?form=MY01OQ&OCID=MY01OQ',
        isEnUsOnly: true,
    },
    {
        contentId: 'MY01OR',
        contentMessage: loc(MY01OW_MY01OR_Text),
        contentLinkButtonText: loc(ubTryNowLinkText),
        contentLinkHref:
            'microsoft-edge:https://microsoftedgewelcome.microsoft.com/en-us/value?form=MY01OR&OCID=MY01OR',
        isEnUsOnly: true,
    },
    {
        contentId: 'MY01OS',
        contentMessage: loc(MY01OX_MY01OS_Text),
        contentLinkButtonText: loc(ubTryNowLinkText),
        contentLinkHref:
            'microsoft-edge:https://microsoftedgewelcome.microsoft.com/en-us/value?form=MY01OS&OCID=MY01OS',
        isEnUsOnly: true,
    },
];
